import React, { Component } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { Growl } from "primereact/growl";
import { Messages } from "primereact/messages";
import "react-datepicker/dist/react-datepicker.css";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import * as helper from "../../../Common/Helper";
import DatePicker from "react-datepicker";
import subMonths from "date-fns/subMonths";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

export default class Patient extends Component {
  constructor(props) {
    super(props);

    var currentTime = new Date();

    this.state = {
      dateClass: "collapse",
      gradeClass: "collapse",
      nameSuggestions: null,
      nameList: [],
      eqList: [],
      eno: "",
      name: "",
      statusFilter: "",
      disposeList: [],
      status: [
        { label: "Lent Out", value: "Lent Out" },
        { label: "Returned", value: "Returned" },
        { label: "All", value: "All" }
      ],
      fromMonth: new Date(currentTime.getFullYear(), currentTime.getMonth(), 1),
      toMonth: new Date(
        currentTime.getFullYear(),
        currentTime.getMonth() + 1,
        0
      )
    };
  }

  componentDidMount() {
    if (this.props.reportType === "Tracker") {
      this.LoadNames();
      this.setState({
        disposeFilterClass: "collapse",
        disposeListClass: "collapse",
        trackerClass: ""
      });
    } else if (this.props.reportType === "Dispose") {
      this.setState({
        disposeFilterClass: "row p-1 border",
        disposeListClass: "row p-1 border",
        trackerClass: "collapse"
      });
    }
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <div>
        <h3 align="center">Equipment {this.props.reportType} Report</h3>
        <div className={this.state.trackerClass}>
          <div className="row p-1 border">
            <div className="col col-md-2">Equipment</div>
            <div className="col col-md-3">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Status</div>
            <div className="col col-md-3">
              <Dropdown
                value={this.state.statusFilter}
                options={this.state.status}
                placeholder="Select Status"
                onChange={e => this.setState({ statusFilter: e.target.value })}
              />
            </div>
          </div>
        </div>
        <div className={this.state.disposeFilterClass}>
          <div className="col col-md-2 ">From Month</div>
          <div className="col col-md-3">
            <DatePicker
              selected={this.state.fromMonth}
              onChange={e => {
                this.setState({ fromMonth: e });
              }}
              dateFormat="MMM-yyyy"
              showMonthYearPicker
            />
          </div>
          <div className="col col-md-2">To Month</div>
          <div className="col col-md-3">
            <DatePicker
              selected={this.state.toMonth}
              onChange={e => this.setState({ toMonth: e })}
              dateFormat="MMM-yyyy"
              showMonthYearPicker
            />
            &nbsp;&nbsp;
            <button
              onClick={this.onFilterClick}
              className="btn btn-primary btn-md mr-2"
            >
              Filter
            </button>
          </div>
        </div>
        <div className={this.state.disposeListClass}>
          <div className="ag-theme-blue col col-md-12" style={this.getHeight()}>
            <AgGridReact
              rowData={this.state.disposeList}
              pagination={true}
              sorting={true}
              filter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
              rowSelection="multiple"
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                width={50}
                checkboxSelection
                filter={false}
                resizable
              />

              <AgGridColumn
                field="txnDate"
                headerName="Date"
                width={120}
                sortable
                resizable
                filter
                valueFormatter={helper.dateFormatter}
              />
              <AgGridColumn
                field="name"
                headerName="Equipment"
                width={130}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="desc"
                headerName="Description"
                width={150}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="qty"
                headerName="Quantity"
                width={150}
                sortable
                resizable
                filter
              />
            </AgGridReact>
          </div>
        </div>
        <div className="row p-1 border">
          <button
            onClick={this.onGenerateClick}
            className="btn btn-primary btn-md mr-2"
          >
            Generate Report
          </button>
        </div>
        <Messages ref={el => (this.messages = el)} />
        <Growl ref={el => (this.growl = el)} />
      </div>
    );
  }

  onFilterClick = e => {
    const obj = {
      fromDate: this.state.fromMonth,
      toDate: new Date(
        this.state.toMonth.getFullYear(),
        this.state.toMonth.getMonth() + 1,
        0
      )
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/disposeList",
        obj
      )
      .then(response => {
        this.setState({ disposeList: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  getHeight() {
    var hgt = window.innerHeight - 160;
    return { height: hgt + "px" };
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/equipment/getNames"
      )
      .then(response => {
        this.setState({ eqList: response.data });
        let nameData = response.data;
        nameData.forEach(function(item) {
          _nameList.push(item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  onNameSelect = e => {
    let results = this.state.eqList.filter(t => {
      return t.name.toLowerCase() === e.value.toLowerCase();
    })[0];

    this.setState({ eno: results.eno, name: results.name });
  };

  onGenerateClick = e => {
    e.preventDefault();

    if (this.props.reportType === "Tracker") {
      const obj = {
        status: this.state.statusFilter,
        eno: this.state.eno
      };
      this.props.onClick(this.props.reportType, obj);
    } else if (this.props.reportType === "Dispose") {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data);
      const selectedDataStringPresentation = selectedData
        .map(node => node._id)
        .join(",");

      const ip = {
        count: selectedNodes.length,
        ids: selectedDataStringPresentation
      };

      if (selectedNodes.length > 0) {
        this.props.onClick(this.props.reportType, ip);
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "Select Entry !!"
        });
      }
    }
  };
}
